module.exports = __webpack_public_path__ + "static/img/advantage6.359620e7.png";